import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'student-rank-levels';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}

export function restore(id, data) {
  return post({
    url: `${url}/${id}`,
    data,
  });
}
